import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { formatApiError } from "@/lib/auth";
import { toast } from "sonner";
import { Truck, LockKey } from "@phosphor-icons/react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ResetPasswordPage() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (password !== confirm) {
      setError("Les mots de passe ne correspondent pas");
      return;
    }
    if (password.length < 6) {
      setError("Mot de passe trop court (min 6 caractères)");
      return;
    }
    setSubmitting(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Mot de passe réinitialisé. Connectez-vous.");
      navigate("/login");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || "Erreur");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center grid-bg">
      <div className="w-full max-w-md mx-4">
        <div className="flex items-center gap-3 mb-8 justify-center">
          <div className="bg-zinc-900 text-white p-3">
            <Truck size={28} weight="bold" />
          </div>
          <div>
            <div
              className="text-3xl font-black uppercase tracking-tighter leading-none"
              style={{ fontFamily: "Chivo" }}
            >
              FLOTTE NY TRANS
            </div>
            <div className="label-tag mt-1">Réinitialisation</div>
          </div>
        </div>

        <div className="bg-white border border-zinc-900 brutalist-shadow p-6">
          <h1
            className="text-2xl font-black uppercase tracking-tight mb-5"
            style={{ fontFamily: "Chivo" }}
          >
            Nouveau mot de passe
          </h1>
          {!token ? (
            <div className="bg-red-50 border border-red-600 text-red-700 px-3 py-3 text-sm">
              Lien invalide. Demandez un nouveau lien depuis la page de connexion.
            </div>
          ) : (
            <form onSubmit={onSubmit} className="space-y-3">
              <div>
                <Label className="label-tag">Nouveau mot de passe</Label>
                <Input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="rounded-none border-zinc-900 mono"
                  required
                  data-testid="reset-password"
                />
              </div>
              <div>
                <Label className="label-tag">Confirmer</Label>
                <Input
                  type="password"
                  value={confirm}
                  onChange={(e) => setConfirm(e.target.value)}
                  className="rounded-none border-zinc-900 mono"
                  required
                  data-testid="reset-confirm"
                />
              </div>
              {error && (
                <div className="bg-red-50 border border-red-600 text-red-700 px-3 py-2 text-sm">
                  {error}
                </div>
              )}
              <button
                type="submit"
                disabled={submitting}
                className="w-full bg-zinc-900 text-white py-3 text-xs uppercase tracking-widest font-bold hover:bg-zinc-700 disabled:opacity-50"
                data-testid="reset-submit"
              >
                {submitting ? "…" : "Réinitialiser"}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
